var _circle, _circle2, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFB32F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 24.0003,
    cy: 24.0003,
    r: 16.2581,
    fill: "#FFB32F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7825_14733",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 14,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.71,
    y: 14.7109,
    width: 18.5806,
    height: 18.5806,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7825_14733)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8195 30.9667C16.6775 30.9667 16.5485 30.9313 16.4324 30.8603C16.3162 30.7893 16.2259 30.6958 16.1614 30.5796C16.0969 30.4635 16.0614 30.3377 16.0549 30.2022C16.0485 30.0667 16.084 29.9345 16.1614 29.8054L23.3227 17.4183C23.4001 17.2893 23.5001 17.1925 23.6227 17.128C23.7453 17.0635 23.8711 17.0312 24.0001 17.0312C24.1291 17.0312 24.2549 17.0635 24.3775 17.128C24.5001 17.1925 24.6001 17.2893 24.6775 17.4183L31.8388 29.8054C31.9162 29.9345 31.9517 30.0667 31.9453 30.2022C31.9388 30.3377 31.9033 30.4635 31.8388 30.5796C31.7743 30.6958 31.684 30.7893 31.5678 30.8603C31.4517 30.9313 31.3227 30.9667 31.1807 30.9667H16.8195ZM18.1549 29.4183H29.8453L24.0001 19.3538L18.1549 29.4183ZM24.0001 28.6442C24.2195 28.6442 24.4033 28.57 24.5517 28.4216C24.7001 28.2732 24.7743 28.0893 24.7743 27.87C24.7743 27.6506 24.7001 27.4667 24.5517 27.3183C24.4033 27.17 24.2195 27.0958 24.0001 27.0958C23.7807 27.0958 23.5969 27.17 23.4485 27.3183C23.3001 27.4667 23.2259 27.6506 23.2259 27.87C23.2259 28.0893 23.3001 28.2732 23.4485 28.4216C23.5969 28.57 23.7807 28.6442 24.0001 28.6442ZM24.0001 26.3216C24.2195 26.3216 24.4033 26.2474 24.5517 26.099C24.7001 25.9506 24.7743 25.7667 24.7743 25.5474V23.2248C24.7743 23.0054 24.7001 22.8216 24.5517 22.6732C24.4033 22.5248 24.2195 22.4506 24.0001 22.4506C23.7807 22.4506 23.5969 22.5248 23.4485 22.6732C23.3001 22.8216 23.2259 23.0054 23.2259 23.2248V25.5474C23.2259 25.7667 23.3001 25.9506 23.4485 26.099C23.5969 26.2474 23.7807 26.3216 24.0001 26.3216Z",
    fill: "#FFB32F"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.cd712a7a.svg";
export { ForwardRef as ReactComponent };